import { Box } from '../../shared_components/UI/Box'
import { ThemedLink } from '../../shared_components/ThemedButton'
import { H2, H4 } from '../../shared_components/Library/Typeography'

const NotFound = () => {
  return (
    <Box padding="196px 0 64px 0">
      <Box g={24} dc c pad="section">
        <H2 uc>Unable to load page</H2>
        <H4>Please try again later.</H4>
        <Box pad="l" c g={12}>
          <ThemedLink to="/">Go to Home</ThemedLink>
        </Box>
      </Box>
    </Box>
  )
}

export default NotFound
